export const ANALYSIS_GROUPS = {
    policy: { label: "Policy" },
    volatility: { label: "Volatility" },
    yields: { label: "Yields" },
    seasonality: { label: "Seasonality" },
    positioning: { label: "Positioning" },
    flow: { label: "Flow" },
    macro: { label: "Macro" },
    liquidity: { label: "Liquidity" },
};

export const DEFAULT_CATALYSTS = {
    Indices: ["USDX", "EURX", "JPYX", "S&P500", "NASDAQ", "RUSSELL 2000"],
    Forex: ["EURUSD", "USDJPY", "USDCHF", "GBPUSD", "USDCAD", "AUDUSD"],
    Commodities: ["XAUUSD", "XAGUSD", "USOIL"],
    Crypto: ["BTCUSD", "ETHUSD"]
};

export const SECTIONS = {
    "economy": {
        label: "Economy",
        path: "/economy",
        tabs: [
            { key: "country-health", label: "Economic Health" },
            { key: "indicators", label: "Economic Indicators" },
            { key: "central-banks", label: "Central Banks" },
        ],
    },
    "fundamentals": {
        label: "Fundamentals",
        path: "/fundamentals",
        tabs: [
            { key: "macro", label: "Macro" },
            { key: "geopolitics", label: "Geopolitics" },
            { key: "micro", label: "Micro" },
        ],
    },
    "market-internals": {
        label: "Market Internals",
        path: "/market-internals",
        tabs: [
            { key: "liquidity", label: "Liquidity" },
            { key: "rates-pricing", label: "Rates Pricing" },
            { key: "yields", label: "Yields" },
            { key: "risk-regime", label: "Risk Regime" },
            { key: "breadth-sentiment", label: "Breadth & Sentiment" },
            { key: "positioning", label: "Positioning" },
            { key: "flow", label: "Flow" },
            { key: "seasonality", label: "Seasonality" },
        ],
    },
    "market-overview": {
        label: "Market Overview",
        path: "/market-overview",
        tabs: [
            { key: "commodities", label: "Commodities" },
            { key: "indices", label: "Indices" },
            { key: "forex", label: "Forex" },
            { key: "crypto", label: "Crypto" },
        ],
    },
    "seasonality": {
        label: "Seasonality",
        path: "/seasonality",
        tabs: [],
    },
    "intermarket": {
        label: "Intermarket",
        path: "/intermarket",
        tabs: [
            { key: "cross-assets", label: "Cross Asset" },
            { key: "cross-sectors", label: "Cross Sector" },
            { key: "asset-correlation", label: "Asset Correlation" },
            { key: "currency-strength", label: "Currency Strength" }
        ],
    },
    "upcoming-events": {
        label: "Upcoming Events",
        path: "/upcoming-events",
        tabs: [],
    },
    "chart-analysis": {
        label: "Chart Analysis",
        path: "/chart-analysis",
        tabs: [],
    },
    "metrics": {
        label: "Metrics",
        path: "/metrics",
        tabs: [
            { key: "journal", label: "Journal" },
            { key: "statistics", label: "Statistics" },
            { key: "calculator", label: "Position calculator" },
            { key: "ideas", label: "Ideas" },
        ],
    },
};
